function convertDisplayPriceInputs(form) {
  const priceRange = form.querySelector('price-range[data-convert-display-price]');
  if (!priceRange) {
    return;
  }

  const factor = parseFloat(priceRange.dataset.displayPriceFactor);
  const catalogMax = parseInt(priceRange.dataset.catalogRangeMax, 10);
  if (!factor || factor >= 1) {
    return;
  }

  const gteInput = form.querySelector('[name="filter.v.price.gte"]');
  const lteInput = form.querySelector('[name="filter.v.price.lte"]');

  if (gteInput?.value) {
    const displayValue = parseInt(gteInput.value, 10);
    gteInput.dataset.displayValue = gteInput.value;

    if (displayValue <= 0) {
      gteInput.value = '';
    } else {
      gteInput.value = String(Math.ceil(displayValue / factor));
    }
  }

  if (lteInput?.value) {
    const displayValue = parseInt(lteInput.value, 10);
    lteInput.dataset.displayValue = lteInput.value;

    if (displayValue >= catalogMax) {
      lteInput.value = '';
    } else {
      lteInput.value = String(Math.floor(displayValue / factor));
    }
  }
}

function restoreDisplayPriceInputs(form) {
  const gteInput = form.querySelector('[name="filter.v.price.gte"]');
  const lteInput = form.querySelector('[name="filter.v.price.lte"]');

  if (gteInput?.dataset.displayValue) {
    gteInput.value = gteInput.dataset.displayValue;
    delete gteInput.dataset.displayValue;
  }

  if (lteInput?.dataset.displayValue) {
    lteInput.value = lteInput.dataset.displayValue;
    delete lteInput.dataset.displayValue;
  }
}

document.addEventListener('submit', (event) => {
  const form = event.target.closest('[is="facets-form"]');
  if (!form) {
    return;
  }

  convertDisplayPriceInputs(form);
}, true);

document.addEventListener('facet:update', () => {
  document.querySelectorAll('[is="facets-form"]').forEach((form) => restoreDisplayPriceInputs(form));
});

class FacetValues extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-action="toggle"]');
    if (!this.toggle) {
      return;
    }

    this.toggle.addEventListener('click', () => this.toggleExpanded());
  }

  toggleExpanded() {
    const expanded = !this.hasAttribute('data-expanded');

    if (expanded) {
      this.setAttribute('data-expanded', '');
    } else {
      this.removeAttribute('data-expanded');
    }

    const labelMore = this.toggle.querySelector('[data-label-more]');
    const labelLess = this.toggle.querySelector('[data-label-less]');

    if (expanded) {
      labelMore?.setAttribute('hidden', '');
      labelLess?.removeAttribute('hidden');
    } else {
      labelMore?.removeAttribute('hidden');
      labelLess?.setAttribute('hidden', '');
    }
  }
}

class CollectionLoadMore extends HTMLElement {
  connectedCallback() {
    // The control is now a real <a href="?page=N"> so search engines can crawl
    // deeper pages. For JS users we intercept the click and append via AJAX
    // instead of navigating. Fall back to a <button> for older markup.
    this.button = this.querySelector('a[data-url], button[data-url]');
    if (!this.button) {
      return;
    }

    this.button.addEventListener('click', (event) => {
      // Prevent the anchor from navigating; do the AJAX append instead.
      event.preventDefault();
      this.loadNextPage();
    });
  }

  async loadNextPage() {
    if (this.loading) {
      return;
    }
    const url = this.button.dataset.url;
    const productListId = this.getAttribute('product-list-id');
    const productList = document.getElementById(productListId);

    if (!url || !productList) {
      return;
    }

    this.loading = true;
    this.button.setAttribute('aria-disabled', 'true');
    this.button.setAttribute('aria-busy', 'true');

    try {
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
      const response = await fetch(url);
      const html = await response.text();
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const sectionId = this.getAttribute('section-id');
      const newSection = doc.getElementById(`shopify-section-${sectionId}`) || doc.querySelector('.shopify-section');

      if (!newSection) {
        return;
      }

      const newProductList = newSection.querySelector('.product-list');
      if (newProductList) {
        [...newProductList.children].forEach((item) => productList.appendChild(item));
      }

      const newLoadMore = newSection.querySelector('collection-load-more');
      if (newLoadMore) {
        this.replaceWith(document.importNode(newLoadMore, true));
      } else {
        this.remove();
      }

      const pageUrl = new URL(url, window.location.origin);
      pageUrl.searchParams.delete('section_id');
      history.pushState({}, '', pageUrl.toString());
    } catch (error) {
      this.loading = false;
      this.button.removeAttribute('aria-disabled');
      this.button.removeAttribute('aria-busy');
    }
  }
}

if (!window.customElements.get('facet-values')) {
  window.customElements.define('facet-values', FacetValues);
}

if (!window.customElements.get('collection-load-more')) {
  window.customElements.define('collection-load-more', CollectionLoadMore);
}
